import React from "react";
import { Link } from "react-router-dom";
import CommentViewItem from "./CommentViewItem";
const CommentView = (props) => {
  return (
    <main className='CommentViewmain'>
      <div className='CommentViewHeader'>
        <img
          src='/public/assets/icons/arrowHeader.svg'
          onClick={props.modalToggler}
          alt='close icon'
        />
        <span>{` ${props.comments.length} دیدگاه`}</span>
      </div>
      <div className='CommentView'>
        <div className='HeadCommentView'>
          <div className='Text'>
            <span className='Score'>امتیاز </span>
            <span className='Number'>{props.avg_rate} </span>
            <span className='Score'>از 5 </span>
          </div>
          <p> {props.comments.length} دیدگاه ثبت شده است </p>
        </div>
        {props.comments.length ? (
          <>
            {props.comments.map((comment) => (
              <CommentViewItem comment={comment} />
            ))}
          </>
        ) : null}
        {props?.vendor_item_id ? (
          <Link to={`/addComment/${props.vendor_item_id}/${props.item_id}`}>
            <button className='CommentviewBtn'>
              <img src='/public/assets/pen.svg' alt='Comment' />
            </button>
          </Link>
        ) : null}
      </div>
    </main>
  );
};

export default CommentView;
